import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from '../../../../core/notification.service'
import { Store } from '@ngrx/store'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Component, OnInit } from '@angular/core'
import { configurationOptionActions } from '../../configuration-option.actions'
import { AppState } from 'src/app/core/core.state'
import { catchError, take, timeout } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { getEnumAsArray } from '../../../../shared/until'
import { EmployeeBookingTypes } from '../../../employee-booking/employee-booking'
import { ConfigOptionsKeys } from '../../../../shared/constants'

type EmployeeBookingConfig = {
  typeEditable: boolean
  productEditable: boolean
  startTimeEditable: boolean
  endTimeEditable: boolean
  contractEditable: boolean
  descriptionVisible: boolean
  descriptionRequired: boolean
  descriptionEditable: boolean
  additionalInfoVisible: boolean
  additionalInfoRequired: boolean
  additionalInfoEditable: boolean
  cancelBookingActive: boolean
  canChange: boolean
  bookingTypes: number[]
}

@Component({
  selector: 'employee-booking-config-card',
  templateUrl: './employee-booking-config-card.component.html',
  styleUrls: ['./employee-booking-config-card.component.scss']
})
export class EmployeeBookingConfigCardComponent implements OnInit {
  public form: UntypedFormGroup
  public isCollapsed = true
  public formValues$: Observable<{ value: string; id: number }>
  public configBooking: EmployeeBookingConfig & { id: number }
  public bookingTypes = getEnumAsArray(EmployeeBookingTypes)

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      typeEditable: [null, []],
      productEditable: [null, []],
      startTimeEditable: [null, []],
      endTimeEditable: [null, []],
      contractEditable: [null, []],
      descriptionVisible: [null, []],
      descriptionRequired: [null, []],
      descriptionEditable: [null, []],
      additionalInfoVisible: [null, []],
      additionalInfoRequired: [null, []],
      additionalInfoEditable: [null, []],
      cancelBookingActive: [null, []],
      canChange: [null, []],
      bookingTypes: [[], []]
    })

    this.formValues$ = this.store.select(
      configurationOptionSelectors.selectByKey,
      ConfigOptionsKeys.EMPLOYEE_BOOKING
    )
    this.formValues$.pipe(take(1)).subscribe((formValues) => {
      if (formValues?.value) {
        this.configBooking = {
          ...JSON.parse(formValues?.value),
          id: formValues.id
        }
      }
    })
  }

  onFormSubmit(): void {
    if (this.configBooking) {
      this.store.dispatch(
        configurationOptionActions.updateOneById({
          id: this.configBooking.id,
          params: {
            value: JSON.stringify(this.form.value)
          }
        })
      )
    } else {
      this.store.dispatch(
        configurationOptionActions.createOne({
          entity: {
            key: ConfigOptionsKeys.EMPLOYEE_BOOKING,
            value: JSON.stringify(this.form.value)
          }
        })
      )
    }
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError(() => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  public patchValueForm(field, value: boolean) {
    let patchValue = {}
    patchValue[field] = value
    this.form.patchValue(patchValue)
  }
}
